// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"227":"5320ead7","521":"4bd4e732"}[chunkId] + ".js";
};